import { render, staticRenderFns } from "./DocumentDownloads.vue?vue&type=template&id=8e22d3da&"
import script from "./DocumentDownloads.vue?vue&type=script&lang=js&"
export * from "./DocumentDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports